import { render, staticRenderFns } from "./RestoreUnpinnedModal.vue?vue&type=template&id=242b70a2&scoped=true"
import script from "./RestoreUnpinnedModal.vue?vue&type=script&lang=js"
export * from "./RestoreUnpinnedModal.vue?vue&type=script&lang=js"
import style0 from "./RestoreUnpinnedModal.vue?vue&type=style&index=0&id=242b70a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242b70a2",
  null
  
)

export default component.exports